<template>
  <div class="prevEdition">
    <router-link :to="getRoute()">
      <button class="heading">
        previous edition >
      </button>
    </router-link>
    <div class="prev-container" :style="`grid-template-columns: repeat(${isEvent? 4 : 3}, 1fr)`">
      <router-link
        v-if="isEvent"
        :to="{ name: 'PDFGuide', params: { isEvent, statistics: true }}"
      >
        <i class="fa fa-chart-bar" title="Statistics" aria-hidden="true"></i>
      </router-link>
      <router-link :to="{ name: 'VideoGallery', params: { isEvent }}">
        <i class="fas fa-video" title="Video"></i>
      </router-link>
      <router-link :to="{ name: 'ImageGallery', params: { isEvent }}">
        <i class="fas fa-images" title="Gallery"></i>
      </router-link>
      <router-link
        :to="{ name: 'PDFGuide', params: { isEvent, statistics: false}}"
        style="border-right:unset"
      >
        <i class="fas fa-book-open" title="Guide" aria-hidden="true"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PreviousEdition',
  data() {
    return {
      isEvent: false,
      currentEvent: {},
    };
  },
  computed: {
    ...mapGetters({
      event: 'events/fetchEvent',
      award: 'awards/award',
      prevEvent: 'events/prevEvent',
    }),
  },
  async mounted() {
    if (this.$route.path.includes('events')) {
      this.isEvent = true;
    } else { this.isEvent = false; }
  },
  methods: {
    getRoute() {
      const url = this.$route.path;
      let route;
      if (url.includes('events')) {
        route = { name: 'standardEvent', params: { eventId: this.prevEvent.id, slug: this.prevEvent.slug } };
      }
      if (url.includes('awards')) {
        route = { name: 'globalAwardsEvents', params: { awardId: this.prevEvent.id, slug: this.prevEvent.slug } };
      }
      return this.prevEvent.id ? route : '';
    },
  },
};
</script>

<style scoped>
.prevEdition {
  color: white;
  line-height: 39px;
  margin-top: 0.5rem;
  height: 95px;
}
.prevEdition> a >.heading{
  background: #BD9D5F;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  height: 45px;
  border: unset;
  border-radius: 0 10px 0 0;
  width: 100%;
  color: white;
  outline: none;
}
.prevEdition> .heading>a{
  color: white;
}
.prevEdition>.heading:hover{
 opacity: 0.5;
}
.prev-container{
  background-color: white;
  display: grid;
  grid-gap: 2px;
  border-radius: 0 0 10px 10px;
}
.prev-container> a {
  border-right: 1px solid #c9ac7e;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 6px;
  height: 52px;
  text-decoration: none;
}
.prev-container> a i{
  color: #c9ac7e;
  font-size: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .prevEdition {
    border-radius: 0 10px 0 0;
    overflow: hidden;
    height: 82px;
  }
  .prevEdition> a >.heading {
    height: 36px;
    padding: 0;
    font-size: 11px;
    color: #BD9D5F;
    background-color: #fff;
  }
  .prev-container {
    background-color: #ebebeb;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
  }
  .prev-container > a {
    border-right: unset;
    height: 36px;
  }
  .prev-container> a i {
    color: #7f7f7f;
  }
}
</style>
